// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"fb80e69c","510":"4e9ff889","725":"7f4ccb67"}[chunkId] + ".chunk.js";
};